/* eslint-disable import/prefer-default-export */

import { AnyJson, JsonObject } from '@ts/json'
import { isArray, isBoolean, isNumber, isString } from 'util'

export const objectFrom = (input: AnyJson): JsonObject => {
  if (input && !isString(input) && !isArray(input) && !isNumber(input) && !isBoolean(input)) {
    return input
  }
  return {}
}

export const arrayOfStringsFrom = (input: AnyJson): string[] => {
  if (isArray(input) && isString(input[0])) {
    return input as string[]
  }
  return []
}
